/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import "moment-timezone";
import React from "react";
import Moment from "react-moment";
import {
  DDD_DD_MMM_YYYY_HH_MM_SS_A,
  TIME_ZONE
} from "../../../../../utils/const";
export const ConfirmationDateFormatter = (cellContent, row, rowIndex) => {
  const { confirmation_date } = row;
  return (
    <>
      <div className="d-flex align-items-center">
        {confirmation_date ? (
          <Moment
            date={confirmation_date}
            format={DDD_DD_MMM_YYYY_HH_MM_SS_A}
            tz={TIME_ZONE}
          />
        ) : (
          "-"
        )}
      </div>
      <> </>
    </>
  );
};
